import React, {useContext, useState, useEffect} from "react"

import Data from "../../../data"
import Config from "../../../config"

// providers and contexts
import {CatalogueContext} from "../../../context"

function Activity(props) {
  // state
  const [activity, setActivity] = useState(null)

  // contexts
  let catalogue = useContext(CatalogueContext)

  // slug (provided by react-router)
  let slug = props.match.params.slug

  // load the activity
  useEffect(() => {
    if(catalogue.isReady) {
      // retrieve the activity
      let a = Data.Catalogue.getActivityBySlug(slug)
      // and set the activity
      setActivity(a)
    }
  }, [slug, catalogue.isReady])

  // render
  if(!activity) {
    // TODO implement something pretty
    return <div>loading ...</div>
  }
  else {
    // the lowest price
    let minPrice = activity.__minPricePerPerson;
    return (
      <div id="s-buddy-activity">
        <h1>Buddy Activity</h1>
        <h1>{activity.title}</h1>
        <p className="price">pro Person ab {Config.currency} {minPrice}.- / Person</p> 
  
      </div>
    )
  }
  
}

export default Activity
